$(function () {
  event.preventDefault();
  var myFuncCalls = 0;
  var $userInput = $('#typed-strings li');
  var data = [];

  $userInput.each(function () {
    data.push($(this).text());
  });

  var pos = 0;
  var turn = 0;
  var speed = 200;
/* BEGIN type animation */
  if ($userInput.length > 1) {
    setTimeout(typeWriter, speed);
    var checkOut = data.length - 1;
    function typeWriter() {
      if (pos < data[turn].length) {
        document.getElementById("typed").innerHTML += data[turn].charAt(pos);
        pos++;
        setTimeout(typeWriter, speed);
      } else if (myFuncCalls === checkOut) {
        setTimeout(0, 0)
      } else {
        setTimeout(erase, 0);
      }
    }

    function erase() {
      if (pos >= 0) {
        var str = data[turn].toString().substring(0, pos);
        document.getElementById("typed").innerHTML = str;
        pos--;
        setTimeout(erase, 10);
      } else {
        turn++;
        myFuncCalls++;
        if (turn >= data.length)
          turn = 0;
        setTimeout(typeWriter, speed);
      }
    }

  } else if ($userInput.length === 1) {
    document.getElementById("typed").innerHTML += data[turn];
  }
/* END type animation */
/*BEGIN image container sizing*/
  $('.hero-image').each(function () {
    var $this = $(this);
    if ($(this).children('img').length === 0) {
      $this.css('height', '100%')
    } else {
      $this.css('height', 'auto')
    }
    if ($(this).children('.video_container').length === 1) {
      $this.css('bottom', '0')
      var mql = window.matchMedia("(max-width: 750px)")
  
      mediaqueryresponse(mql)
      
      mql.addListener(mediaqueryresponse)
      
      function mediaqueryresponse(mql) {
        if (mql.matches) {   
          $this.css({'width' : '200%', 'left': '-50%'})
        }
      }
    }
  });
/*END image container sizing*/
/*BEGIN video control styling*/
  $('[data-vid]').each(function () {
    var vidId = $(this).data('vid');
    window._wq = window._wq || [];
    _wq.push({
      id: vidId,
      options: {
        videoFoam: false,
        autoPlay: true,
        playButton: false,
        playbar: false,
        muted: true,
        controlsVisibleOnLoad: false,
        endVideoBehavior: "loop",
        playSuspendedOffScreen: false
      }
    });
  });
/*END video control styling*/
});
